// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BppQGb2j7TfyB5 {
  display: flex;
  margin-bottom: 4px;
  padding: 6px 12px 6px 10px;
  border-radius: 3px;
  font-weight: 500;
}
.mbZDBgJWdQ9AXo {
  margin-left: 8px;
  float: left;
  clear: both;
  transition: transform 85ms ease-in;
  background-color: rgba(0, 0, 0, 0.6);
  color: #c7d1db;
}
.mbZDBgJWdQ9AXo:hover,
.mbZDBgJWdQ9AXo:active {
  transform: translateX(5px);
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
}
.j0Gc9CXbIp07ZQ {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text, #172b4d);
}
.j0Gc9CXbIp07ZQ:hover,
.j0Gc9CXbIp07ZQ:active {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.gMwAd04JA9b_bj {
  margin-right: 8px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `BppQGb2j7TfyB5`,
	"button--legacy": `mbZDBgJWdQ9AXo`,
	"button--hover": `j0Gc9CXbIp07ZQ`,
	"icon": `gMwAd04JA9b_bj`
};
export default ___CSS_LOADER_EXPORT___;
